import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'letter'
})
export class LetterPipe implements PipeTransform {

  transform(value: any): any {
    if (value) {
      return value;
    }
    return null;
  }

}
